export default __webpack_public_path__ + "static/media/kitchen5-beforeA.a4fade78.jpg";